import { AccountType } from "../models";
import { useApi } from "./api";

export const useContact = () => {
  const { $get, $post, objToArray } = useApi();

  const getContacts = async (account_type?: AccountType) => {
    const data = await $get("account/contact/get_contacts/", {account_type:account_type});
    if (!data) return;
    if (data.res && data.res.toLowerCase() === "success") {
      return data.data;
    }
    return [];
  };

  const saveContact = async (receiver_id: string) => {
    try {
      const res = await $post("account/contact/create_contact_from_receiver_id/", { receiver_id }, false );
      // console.log(res);
      return;
    } catch (err) {
      window.alert("Echec d'enregistrement du contact!");
    }
  };

  return { getContacts, saveContact };
};
